import AppRecord from './AppRecord.js'
import APP from '../../../main.js'

class OnboardingStep extends AppRecord {
  dataObject(){
    let dataObject = {}
    dataObject.orig = {}
    dataObject.fields = {}
    this.onboarding_step_data.forEach((stepData) => {
      dataObject[stepData.id] = stepData.formattedValue
      dataObject.orig[stepData.id] = stepData.formattedValue
      dataObject.fields[stepData.id] = { fieldName: stepData.field, tableName: stepData.table }
    });

    // Add method to check if modification of field requires re-reading of entitiy tabs
    dataObject.entityReRead = (stepDataId) => {
      if (dataObject.fields[stepDataId] != null) {
        if (dataObject.fields[stepDataId].tableName == 'clients' &&
            (dataObject.fields[stepDataId].fieldName == 'name' || dataObject.fields[stepDataId].fieldName == 'id')){
              return true
            }
      }
      return false
    }

    dataObject.riskAssessmentReRead = (stepDataId) => {
      if (dataObject.fields[stepDataId] != null) {
        if (
            (dataObject.fields[stepDataId].tableName == 'entities' && (dataObject.fields[stepDataId].fieldName == 'name' || dataObject.fields[stepDataId].fieldName == 'investment_type')) ||
            (dataObject.fields[stepDataId].tableName == 'clients' && (dataObject.fields[stepDataId].fieldName == 'name' || dataObject.fields[stepDataId].fieldName == 'id'))
            ){
              return true
            }
      }
      return false
    }


    return dataObject
  }

  field(tableName, fieldName){
    return this.onboarding_step_data.find((def) => {
      return def.table === tableName && def.field === fieldName
    })
  }

  valueForField(tableName, fieldName){
    let ret = this.field(tableName, fieldName)
    if (ret){
      return ret.value
    }
    return null
  }

  setFieldValue(tableName, fieldName, value){
    let field = this.field(tableName, fieldName)
              
    if (field){
      field.value = value
    }
  }

  setFieldValueFromId(fieldId, newValue){
    let field = this.onboarding_step_data.find((e) => e.id == fieldId);
              
    if (field){
      field.value = newValue;
    }
  }

  valuesForField(tableName, fieldName){
    let ret = this.onboarding_step_data.filter(def => def.table === tableName && def.field === fieldName)
    if (ret){
      return ret
    }
    return null
  }

  get headingText(){
    let headingText = ''
    if (this.step_type == 'client'){
      let existing_client_id = this.valueForField('clients', 'id')
      if (existing_client_id){
        headingText = "KYC " + this.constructor.employeeStore.peopleById.get(Number(existing_client_id))?.name
      }
      
      if (! headingText){
        let namey = this.valueForField('clients', 'name')
        if (namey){
          headingText = "KYC " + namey
        }
      }
    } else if (this.step_type == 'entity'){
      let entityName = this.valueForField('entities', 'name')
      if (entityName){
        headingText = "KYC " + entityName
      }
    }

    if (! headingText){
      headingText = this.heading
    }
    return headingText
  }

  get shown_step_data(){
    let fields = [...this.onboarding_step_data].sort((a, b) => {
      return a.sort_order - b.sort_order;
    });

    let exclusiveFields = fields.filter(f => f.value && f.field_type == 'key_exclusive')

    if (exclusiveFields){
      exclusiveFields.forEach(exc => {
        fields = fields.filter(field => !field.reference || field.id == exc.id || (field.reference && !field.reference.startsWith(exc.reference)))
      })
    }

    return fields
  }

  castStepData(){
    let newSteps = []
    this.onboarding_step_data.forEach((stepData) => {
      newSteps.push(this.constructor.employeeStore.controllers.OnboardingStepDataController.setNewDatum(stepData))
    })
    this.onboarding_step_data = newSteps
  }
}

export default OnboardingStep